import { http } from "config/http";
import { DynamicPricingDataPayload} from "pages/dynamic-pricing";


export const getDynamicPricingGraphData= async (payload: DynamicPricingDataPayload) => {



    try {
        const res: any = await http.post(`get_dynamic_pricing_graph_data`,payload)
        return { result: res?.data.result }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getDynamicPricingData= async (payload: DynamicPricingDataPayload) => {



    try {
        const res: any = await http.post(`get_dynamic_pricing_data`,payload)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getUniqueProducts= async () => {



    try {
        const res: any = await http.get(`get_unique_products?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data.data }
    } catch (error: any) {
        return { error: error.message }
    }
}
